import { render, staticRenderFns } from "./ScopeOfWorksOld.vue?vue&type=template&id=97fae688&"
import script from "./ScopeOfWorksOld.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWorksOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports